module.exports = __webpack_public_path__ + "img/32.0ad8072c.jpg";